'use strict';

var megaMenu = document.querySelector('.megaMenu');
var menuItems = document.querySelectorAll(".megaMenu > li.megamenu__products");

var dropdownBackground = document.querySelector('.megaMenu__drop-background');

[].forEach.call(menuItems, function (item) {
  return item.addEventListener("mouseenter", function () {
    var dropdown = item.querySelector('.megaMenu__dropdown');
    dropdown.classList.add('dropdown--active');
    dropdownBackground.classList.add('megaMenu__drop-background--active');

    setTimeout(function () {
      dropdown.style.opacity = 1;
    });

    var dropdownCoords = dropdown.getBoundingClientRect();
    var megaMenuCoords = megaMenu.getBoundingClientRect();

    var coords = {
      top: dropdownCoords.top - megaMenuCoords.top,
      left: dropdownCoords.left - megaMenuCoords.left,
      width: dropdownCoords.width,
      height: dropdownCoords.height
    };

    dropdownBackground.style.opacity = 1;
    dropdownBackground.style.setProperty('transform', 'translateY(' + coords.top + 'px) \n                                        translateX(' + coords.left + 'px)');
    dropdownBackground.style.width = coords.width + 'px';
    dropdownBackground.style.height = coords.height + 'px';
  });
});

[].forEach.call(menuItems, function (item) {
  return item.addEventListener("mouseleave", function () {
    var dropdown = item.querySelector('.megaMenu__dropdown');
    dropdown.style.opacity = 0;
    dropdownBackground.style.opacity = 0;
    dropdown.classList.remove('dropdown--active');
    dropdownBackground.classList.remove('megaMenu__drop-background--active');
  });
});